import Vue from 'vue';
import './yandexAnalytics.js'
// import './facebookAnalytics.js'

class UnitedAnalytics {

    _try(fn){

        try{
            fn();
        }catch(ex){ console.warn('#### Failed to emit analytics event', ex)}
    }

    signedIn(){

        this._try(()=>Vue.$metrika.reachGoal('website:signin:completed'));

        // Vue.analytics.fbq.event('website:signin:completed', {});
        this._try(()=> Vue.$ga.event({
                eventCategory: 'website',
                eventAction: 'signin',
                eventLabel: 'completed'
            }));
    }

    signedOut(){

        this._try(()=>Vue.$metrika.reachGoal('website:signin:canceled'));

        // Vue.analytics.fbq.event('website:signin:canceled', {});
        this._try(()=> Vue.$ga.event({
                eventCategory: 'website',
                eventAction: 'signin',
                eventLabel: 'canceled'
            }));
    }

    clickedGetSubscription(){

        this._try(()=>Vue.$metrika.reachGoal('website:conversion:getSubscription'));

        // Vue.analytics.fbq.event('website:conversion:getSubscription', {});

        this._try(()=>Vue.$ga.event({
            eventCategory: 'website',
            eventAction: 'conversion',
            eventLabel: 'getSubscription'
        }));

    }

    subscribed(){

        this._try(()=>Vue.$metrika.reachGoal('website:conversion:startedTrial'));

        // Vue.analytics.fbq.event('website:conversion:startedTrial', {});

        this._try(()=>Vue.$bingAdsAnalytics.emitCustomEvent({
            category: 'website',
            action: 'conversion',
            label: 'startedTrial'
        }));

        this._try(()=>Vue.$ga.event({
            eventCategory: 'website',
            eventAction: 'conversion',
            eventLabel: 'startedTrial'
        }));

    }

    unsubscribed(){

        this._try(()=>Vue.$metrika.reachGoal('website:subscription:canceled'));

        // Vue.analytics.fbq.event('website:subscription:canceled', {});

        this._try(()=> Vue.$ga.event({
            eventCategory: 'website',
            eventAction: 'subscription',
            eventLabel: 'canceled'
        }));

    }

}

export default class MetaPlugin {

    static install(Vue, options = {}) {

        options;
        Vue.$UAnalytics = new UnitedAnalytics();

        Vue.prototype.$UAnalytics = Vue.$UAnalytics;

    }

}
